import { lazy } from "react";
import { Navigate } from "react-router-dom";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { ProtectedRoute } from "../../router/ProtectedRoutes";
import { LAWYERED_CHALLAN_ROUTE, LAWYERED_ROUTE } from "./lawyered.constant";

const LawyeredChallanList = Loadable(
  lazy(() =>
    import("./LawyeredChallanList").then(({ LawyeredChallanList }) => ({
      default: LawyeredChallanList,
    }))
  )
);

export const lawyeredRoutes = [
  {
    path: LAWYERED_CHALLAN_ROUTE,
    element: (
      <ProtectedRoute>
        <LawyeredChallanList />
      </ProtectedRoute>
    ),
  },
  {
    path: LAWYERED_ROUTE,
    element: <Navigate to={LAWYERED_CHALLAN_ROUTE} replace />,
  },
  {
    path: "/lawyered-challan",
    element: <Navigate to={LAWYERED_CHALLAN_ROUTE} replace />,
  },
];
